import {useApi} from "~/composables/api/utils/useApi"

export const useContactApi = () => ({
  async send(contactForm) {
    const url = "/contacts"
    const api = useApi()

    return api.makeRequest(url, 'post', contactForm)
  }
})
